import {
    getUrlCreationRepo,postUrlCreationRepo,getOneClickLoginUrlCreationRepo,
    postDownloadCSVRepo,
} from "../repositories/registration/urlCreation";
import { createSlice } from "@reduxjs/toolkit";

const urlCreationSlice = createSlice({
    name: "urlCreationReducer",
    initialState: {
        urlCreationLoading: false,
        urlCreationData: null,
        urlCreationError: null,

        postURLsCreationLoading: false,
        postUrlCreationData: null,
        postUrlCreationError: null,

        oneClickUrlCreationLoading: false,
        oneClickUrlCreationData: null,
        oneClickUrlCreationError: null,

        postDownloadCSVloadingState: false,
        postDownloadCSVData: null,
        postDownloadCSVError: null,
    },
    reducers: {

        getUrlCreationLoading(state, action) {
            return {
                ...state,
                urlCreationLoading: true,
            };
        },
        getUrlCreationSuccess(state, action) {
            return {
                ...state,
                urlCreationLoading: false,
                urlCreationData: action.payload,
            };
        },
        getUrlCreationFailure(state, action) {
            return {
                ...state,
                urlCreationLoading: false,
                urlCreationError: action.payload,
            };
        },
        
        postUrlCreationLoading(state, action) {
            return {
                ...state,
                postURLsCreationLoading: true,
            };
        },
        postUrlCreationSuccess(state, action) {
            return {
                ...state,
                postURLsCreationLoading: false,
                postUrlCreationData: action.payload,
            };
        },
        postUrlCreationFailure(state, action) {
            return {
                ...state,
                postURLsCreationLoading: false,
                postUrlCreationError: action.payload,
            };
        },
        clearPostUrlCreationData(state, action) {
            return {
                ...state,
                postUrlCreationData: null,
                postUrlCreationError:null,
            };
        },

        getOneClickUrlCreationLoading(state, action) {
            return {
                ...state,
                oneClickUrlCreationLoading: true,
            };
        },
        getOneClickUrlCreationSuccess(state, action) {
            return {
                ...state,
                oneClickUrlCreationLoading: false,
                oneClickUrlCreationData: action.payload,
            };
        },
        getOneClickUrlCreationFailure(state, action) {
            return {
                ...state,
                oneClickUrlCreationLoading: false,
                oneClickUrlCreationError: action.payload,
            };
        },

        postDownloadCSVLoading(state, action) {
            return {
                ...state,
                postDownloadCSVloadingState: true,
            };
        },
        postDownloadCSVSuccess(state, action) {
            return {
                ...state,
                postDownloadCSVloadingState: false,
                postDownloadCSVData: action.payload,
            };
        },
        postDownloadCSVFailure(state, action) {
            return {
                ...state,
                postDownloadCSVloadingState: false,
                postDownloadCSVError: action.payload,
            };
        },
        clearPostDownloadCSV(state, action) {
            return {
                ...state,
                postDownloadCSVData: null,
                postDownloadCSVError:null,
            };
        },

    },
});
export const {
    getUrlCreationLoading,
    getUrlCreationSuccess,
    getUrlCreationFailure,

    postUrlCreationLoading,
    postUrlCreationSuccess,
    postUrlCreationFailure,
    clearPostUrlCreationData,

    getOneClickUrlCreationLoading,
    getOneClickUrlCreationSuccess,
    getOneClickUrlCreationFailure,

    postDownloadCSVLoading,
    postDownloadCSVSuccess,
    postDownloadCSVFailure,
    clearPostDownloadCSV,

} = urlCreationSlice.actions;

export const getUrlCreation = (params) => {
    return async (dispatch) => {
        dispatch(getUrlCreationLoading());
        await getUrlCreationRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getUrlCreationSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getUrlCreationFailure(error.message));
                }
            });
    };
};


export const postUrlCreation = (params) => {
    return async (dispatch) => {
        dispatch(postUrlCreationLoading());
        await postUrlCreationRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300) {
                    dispatch(postUrlCreationSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postUrlCreationFailure(error.response?.data));
                }
            });
    };
};

export const getOneClickUrlCreation = (params) => {
    return async (dispatch) => {
        dispatch(getOneClickUrlCreationLoading());
        await getOneClickLoginUrlCreationRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(getOneClickUrlCreationSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getOneClickUrlCreationFailure(error.message));
                }
            });
    };
};

export const postOneClickUrlCreation = (params) => {
    return async (dispatch) => {
        dispatch(postDownloadCSVLoading());
        await postDownloadCSVRepo(params)
            .then((response) => {
                if (response?.status >= 200 || response?.status <= 300){
                    dispatch(postDownloadCSVSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postDownloadCSVFailure(error.response?.data));
                }
            });
    };
};

export default urlCreationSlice.reducer;